<template>
  <v-menu
  v-model="open"
  :close-on-content-click="false"
  left>
    <template #activator="{ on: menu, attrs }">
      <v-tooltip bottom color="primary">
        <template #activator="{ on: tooltip }">
          <v-icon
          color="primary"
          class="mr-2"
          v-bind="attrs"
          v-on="{ ...menu, ...tooltip }"
          id="bid-filter-activator"
          data-testid="bid-filter">
            mdi-filter
          </v-icon>
        </template>
        <span class="subtitle-1 white--text">{{ $t('filter') }}</span>
      </v-tooltip>
    </template>
    <v-card width="400px" v-if="open" id="bid-filter-menu">
      <v-card-title class="primary white--text">
        {{ $t('filterBids') }}
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row dense>
            <v-col cols="12">
              <TractAutocomplete
              clearable
              :tractFilter="isDeliveredTract"
              :propTractId="builder.tractId"
              @tract-chosen="builder.tractId = $event ? $event.tractId : undefined"
              @tract-cleared="builder.tractId = undefined"/>
            </v-col>
            <v-col cols="12">
              <AccountAutocomplete
              :onlyExternal="true"
              clearable
              :title="$t('supplier')"
              :accountId="builder.supplierAccountId"
              @account-chosen="builder.supplierAccountId = $event ? $event.accountId : undefined"/>
            </v-col>
            <v-col cols="12">
              <AccountAutocomplete
              :onlyInternal="true"
              clearable
              :title="$t('destination')"
              :accountId="builder.destinationAccountId"
              @account-chosen="builder.destinationAccountId = $event ? $event.accountId : undefined"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-checkbox
            v-model="builder.unassignedOnly"
            color="primary"
            hide-details
            :label="$t('unassignedOnly')"/>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-btn color="primary" outlined @click="resetClicked">{{ $t('reset') }}</v-btn>
        <v-spacer/>
        <v-btn color="primary" id="bid-filter-apply" :disabled="!changed" @click="applyClicked">{{ $t('apply') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { cloneDeep } from 'lodash'
import { isDeliveredTract } from '@/model/Tract.js'

const emptyFilter = () => ({
  tractId: undefined,
  supplierAccountId: undefined,
  destinationAccountId: undefined,
  unassignedOnly: false
})

export default {
  name: 'BidFilter',

  components: {
    TractAutocomplete: () => import('@/components/autocomplete/TractAutocomplete.vue'),
    AccountAutocomplete: () => import('@/components/autocomplete/AccountAutocomplete.vue')
  },

  props: {
    filter: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    open: false,
    changed: false,
    builder: emptyFilter()
  }),

  watch: {
    open (isOpen) {
      if (isOpen) {
        this.builder = cloneDeep(this.filter)
        this.$nextTick(() => { this.changed = false })
      }
    },

    builder: {
      handler () {
        this.changed = true
      },
      deep: true
    }
  },

  methods: {
    isDeliveredTract,

    applyClicked () {
      this.$emit('filter-applied', cloneDeep(this.builder))
      this.open = false
    },

    resetClicked () {
      this.builder = emptyFilter()
      this.$emit('filter-applied', emptyFilter())
      this.open = false
    }
  }
}
</script>
